import { useUniversalClinicCarePlanPreview } from "@/features/Charting/CarePlanPreview/network/useUniversalClinicCarePlanPreview";
import { useEffect } from "react";
import { UniversalClinicCarePlanPreviewContent } from "./UniversalClinicCarePlanPreviewContent";

interface CarePlanPreviewStepProps {
  carePlanIds: string[];
  onReadyChange: (isReady: boolean) => void;
}

export function CarePlanPreviewStep({
  carePlanIds,
  onReadyChange,
}: CarePlanPreviewStepProps) {
  const {
    mutate: fetchPreview,
    data,
    isPending: isLoading,
    isError,
    reset,
  } = useUniversalClinicCarePlanPreview();
  const hasCareContent = Boolean(
    (data?.careplans?.length ?? 0) > 0 &&
      data?.careplans?.every((carePlan) => carePlan.hasCareContent),
  );

  useEffect(() => {
    onReadyChange(false);
    if (carePlanIds.length > 0) {
      fetchPreview({ careplanIds: carePlanIds });
    }

    return () => {
      onReadyChange(false);
      reset();
    };
  }, [carePlanIds, fetchPreview, onReadyChange, reset]);

  useEffect(() => {
    onReadyChange(!isLoading && !isError && hasCareContent);
  }, [hasCareContent, isError, isLoading, onReadyChange]);

  return (
    <UniversalClinicCarePlanPreviewContent
      carePlanIds={carePlanIds}
      carePlans={data?.careplans}
      isLoading={isLoading}
      isError={isError}
      hasCareContent={hasCareContent}
    />
  );
}
